<template>
  <div>
    <!-- 标题 -->
    <div class="instance-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ $t('aiMonitor.detailTitleInstance') }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="instance-top">
      <Row :gutter="4">
        <Col span="4">
          <DatePicker
            type="date"
            :options="options"
            :placeholder="$t('aiMonitor.selectDate')"
            v-model="timeType"
            @on-change="changeTimeType(timeType)"
            style="width:100%;"
          ></DatePicker>
        </Col>
        <Col span="2">
          <Button
            @click="returnGo"
            v-hasPermission="['aiMonitor:applicationSystemAlarm:return']"
            >{{ $t('aiMonitor.return') }}</Button
          >
        </Col>
      </Row>
    </div>
    <Row :gutter="10" style="margin-bottom: 10px;">
      <!-- instance -->
      <Col span="12">
        <Card :padding="8">
          <div id="cpu" style="width:100%;height: 240px;"></div>
        </Card>
      </Col>
      <Col span="12">
        <Card :padding="8">
          <div id="memory" style="width:100%;height: 240px;"></div>
        </Card>
      </Col>
    </Row>
    <Row :gutter="10" style="margin-bottom: 10px;">
      <!-- instance -->
      <Col span="12">
        <Card :padding="8">
          <div id="networkOut" style="width:100%;height: 240px;"></div>
        </Card>
      </Col>
      <Col span="12">
        <Card :padding="8">
          <div id="networkIn" style="width:100%;height: 240px;"></div>
        </Card>
      </Col>
    </Row>
    <Row :gutter="10" style="margin-bottom: 10px;">
      <!-- instance -->
      <Col span="12">
        <Card :padding="8">
          <div id="InstanceHealthCheck" style="width:100%;height: 240px;"></div>
        </Card>
      </Col>
      <Col span="12">
        <Card :padding="8">
          <div id="SystemHealthCheck" style="width:100%;height: 240px;"></div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import utils from "../../../utils/utils.js";
export default {
  name: "InstanceDetail",
  data() {
    return {
      options: {
        disabledDate(date) {
          return date && date.valueOf() >= new Date();
        }
      },
      timeType: "",
      // echarts实例
      chartCpu: "",
      chartMemory: "",
      chartNetworkOut: "",
      chartNetworkIn: "",

      InstanceHealthCheck: "",
      SystemHealthCheck: "",

      // 数组
      cpuUsage: [],
      cpuUsagePrediction: [],
      memoryUsage: [],
      memoryUsagePrediction: [],
      networkOutflow: [],
      networkOutflowPrediction: [],
      networkInflow: [],
      networkInflowPrediction: [],
      xaxisData: [],

      InstanceHealthCheckData: [],
      SystemHealthCheckData: [],
      InstanceHealthCheckPredictionData: [],
      SystemHealthCheckPredictionData: []
    };
  },
  mounted: function() {
    this.currentDay();
    // 自适应不同屏幕尺寸
    const self = this;
    window.addEventListener("resize", function() {
      self.chartCpu.resize();
      self.chartMemory.resize();
      self.chartNetworkOut.resize();
      self.chartNetworkIn.resize();
      self.InstanceHealthCheck.resize();
      self.SystemHealthCheck.resize();
    });
  },
  methods: {
    // 默认显示当前日期
    currentDay: function() {
      const myDate = new Date();
      const year = myDate.getFullYear();
      const month = myDate.getMonth() + 1;
      const day = myDate.getDate();
      this.timeType = `${year}/${month}/${day}`;
      this.checkApplicationDataPoint();
    },
    // 返回上一页
    returnGo: function() {
      window.history.go(-1);
    },
    /******************查询********************************/
    // 折线图
    checkApplicationDataPoint: function() {
      this.$api.aiForecastDataPoint
        .checkApplicationDataPointStatistics({
          moduleId: this.$route.query.instanceId,
          timeHorizon: utils.methods.formatDate(this.timeType),
          moduleType: 0
        })
        .then(res => {
          if (res.data.xaxisData == undefined) {
            this.xaxisData = [];
          } else {
            this.xaxisData = res.data.xaxisData;
          }

          this.cpuUsage = res.data.cpuUsage;
          this.cpuUsagePrediction = res.data.cpuUsagePrediction;
          this.memoryUsage = res.data.memoryUsage;
          this.memoryUsagePrediction = res.data.memoryUsagePrediction;
          this.networkOutflow = res.data.networkOutflow;
          this.networkOutflowPrediction = res.data.networkOutflowPrediction;
          this.networkInflow = res.data.networkInflow;
          this.networkInflowPrediction = res.data.networkInflowPrediction;

          // 实例健康状态检查
          this.InstanceHealthCheckData = res.data.instanceHealthCheckData;
          this.InstanceHealthCheckPredictionData =
            res.data.instanceHealthCheckPredictionData;
          // 系统健康状态检查
          this.SystemHealthCheckData = res.data.systemHealthCheckData;
          this.SystemHealthCheckPredictionData =
            res.data.systemHealthCheckPredictionData;

          this.all();
        });
    },
    changeTimeType: function() {
      this.checkApplicationDataPoint();
    },
    /******************所有折线图********************************/
    all: function() {
      this.chartCpuLine();
      this.chartMemoryLine();
      this.chartNetworkOutLine();
      this.chartNetworkInLine();
      this.chartInstanceHealthCheckLine();
      this.chartSystemHealthCheckLine();
    },
    /*************折线图*****************************/
    // CPU使用率
    chartCpuLine: function() {
      this.chartCpu = this.$echarts.init(document.getElementById("cpu"));
      this.chartCpu.setOption({
        title: {
          text: this.$t('aiMonitor.charts.cpuUsage'),
          textStyle: {
            color: "#000", //颜色
            fontStyle: "normal", //风格
            fontWeight: "600", //粗细
            fontSize: 13 //大小
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "18px",
          data: [this.$t('aiMonitor.charts.cpuUsage'), this.$t('aiMonitor.charts.cpuUsagePrediction')]
        },
        series: [
          {
            name: this.$t('aiMonitor.charts.cpuUsage'),
            type: "line",
            data: this.cpuUsage,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae"
                }
              }
            }
          },
          {
            name: this.$t('aiMonitor.charts.cpuUsagePrediction'),
            type: "line",
            data: this.cpuUsagePrediction,
            itemStyle: {
              normal: {
                color: "#ceca58",
                lineStyle: {
                  color: "#ceca58"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      });
    },
    // 实例内存使用率
    chartMemoryLine: function() {
      this.chartMemory = this.$echarts.init(document.getElementById("memory"));
      this.chartMemory.setOption({
        title: {
          text: this.$t('aiMonitor.charts.instanceMemoryUsage'),
          textStyle: {
            color: "#000", //颜色
            fontStyle: "normal", //风格
            fontWeight: "600", //粗细
            fontSize: 13 //大小
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "18px",
          data: [this.$t('aiMonitor.charts.instanceMemoryUsage'), this.$t('aiMonitor.charts.instanceMemoryUsagePrediction')]
        },
        series: [
          {
            name: this.$t('aiMonitor.charts.instanceMemoryUsage'),
            type: "line",
            data: this.memoryUsage,
            itemStyle: {
              normal: {
                color: "#ccc",
                lineStyle: {
                  color: "#ccc"
                }
              }
            }
          },
          {
            name: this.$t('aiMonitor.charts.instanceMemoryUsagePrediction'),
            type: "line",
            data: this.memoryUsagePrediction,
            itemStyle: {
              normal: {
                color: "#4671D5",
                lineStyle: {
                  color: "#4671D5"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      });
    },
    // 实例网络输入(MB)
    chartNetworkInLine: function() {
      this.chartNetworkIn = this.$echarts.init(
        document.getElementById("networkIn")
      );
      this.chartNetworkIn.setOption({
        title: {
          text: this.$t('aiMonitor.charts.instanceNetworkInput'),
          textStyle: {
            color: "#000", //颜色
            fontStyle: "normal", //风格
            fontWeight: "600", //粗细
            fontSize: 13 //大小
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "18px",
          data: [this.$t('aiMonitor.charts.instanceNetworkInput'), this.$t('aiMonitor.charts.instanceNetworkInputPrediction')]
        },
        series: [
          {
            name: this.$t('aiMonitor.charts.instanceNetworkInput'),
            type: "line",
            data: this.networkInflow,
            itemStyle: {
              normal: {
                color: "#803500",
                lineStyle: {
                  color: "#803500"
                }
              }
            }
          },
          {
            name: this.$t('aiMonitor.charts.instanceNetworkInputPrediction'),
            type: "line",
            data: this.networkInflowPrediction,
            itemStyle: {
              normal: {
                color: "#FF9B40",
                lineStyle: {
                  color: "#FF9B40"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      });
    },
    // 实例网络输出(MB)
    chartNetworkOutLine: function() {
      this.chartNetworkOut = this.$echarts.init(
        document.getElementById("networkOut")
      );
      this.chartNetworkOut.setOption({
        title: {
          text: this.$t('aiMonitor.charts.instanceNetworkOutput'),
          textStyle: {
            color: "#000", //颜色
            fontStyle: "normal", //风格
            fontWeight: "600", //粗细
            fontSize: 13 //大小
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "18px",
          data: [this.$t('aiMonitor.charts.instanceNetworkOutput'), this.$t('aiMonitor.charts.instanceNetworkOutputPrediction')]
        },
        series: [
          {
            name: this.$t('aiMonitor.charts.instanceNetworkOutput'),
            type: "line",
            data: this.networkOutflow,
            itemStyle: {
              normal: {
                color: "#61a0a8",
                lineStyle: {
                  color: "#61a0a8"
                }
              }
            }
          },
          {
            name: this.$t('aiMonitor.charts.instanceNetworkOutputPrediction'),
            type: "line",
            data: this.networkOutflowPrediction,
            itemStyle: {
              normal: {
                color: "#c23159",
                lineStyle: {
                  color: "#c23159"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      });
    },
    // 实例健康状态检查
    chartInstanceHealthCheckLine: function() {
      this.InstanceHealthCheck = this.$echarts.init(
        document.getElementById("InstanceHealthCheck")
      );
      this.InstanceHealthCheck.setOption({
        title: {
          text: this.$t('aiMonitor.charts.instanceHealthCheck'),
          textStyle: {
            color: "#000", //颜色
            fontStyle: "normal", //风格
            fontWeight: "600", //粗细
            fontSize: 13 //大小
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "18px",
          data: [this.$t('aiMonitor.charts.instanceHealthCheck'), this.$t('aiMonitor.charts.instanceHealthCheckPrediction')]
        },
        series: [
          {
            name: this.$t('aiMonitor.charts.instanceHealthCheck'),
            type: "line",
            data: this.InstanceHealthCheckData,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae"
                }
              }
            }
          },
          {
            name: this.$t('aiMonitor.charts.instanceHealthCheckPrediction'),
            type: "line",
            data: this.InstanceHealthCheckPredictionData,
            itemStyle: {
              normal: {
                color: "#ceca58",
                lineStyle: {
                  color: "#ceca58"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      });
    },
    // 系统健康状态检查
    chartSystemHealthCheckLine: function() {
      this.SystemHealthCheck = this.$echarts.init(
        document.getElementById("SystemHealthCheck")
      );
      this.SystemHealthCheck.setOption({
        title: {
          text: this.$t('aiMonitor.charts.systemHealthCheck'),
          textStyle: {
            color: "#000", //颜色
            fontStyle: "normal", //风格
            fontWeight: "600", //粗细
            fontSize: 13 //大小
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          x: "right",
          y: "18px",
          data: [this.$t('aiMonitor.charts.systemHealthCheck'), this.$t('aiMonitor.charts.systemHealthCheckPrediction')]
        },
        series: [
          {
            name: this.$t('aiMonitor.charts.systemHealthCheck'),
            type: "line",
            data: this.SystemHealthCheckData,
            itemStyle: {
              normal: {
                color: "#91c7ae",
                lineStyle: {
                  color: "#91c7ae"
                }
              }
            }
          },
          {
            name: this.$t('aiMonitor.charts.systemHealthCheckPrediction'),
            type: "line",
            data: this.SystemHealthCheckPredictionData,
            itemStyle: {
              normal: {
                color: "#ceca58",
                lineStyle: {
                  color: "#ceca58"
                }
              }
            }
          }
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function(str) {
              return str.replace(" ", "\n");
            })
          }
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value"
          }
        ]
      });
    }
  }
};
</script>

<style scoped>
.instance-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 8px 4px;
  font-weight: 600;
}

.ivu-col-span-6 {
  margin-bottom: 20px;
}

.instance-top {
  width: 100%;
  height: 53px;
  background-color: #fff;
  padding: 4px 0px 0px 0px;
}

.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/ai_dashboard/InstanceDetail.vue